/* eslint-disable jsx-a11y/alt-text */
import React, { useRef, ChangeEvent, DragEvent } from 'react';
import { styled } from 'styled-components';
import { UploadIcon } from '../Icons';

interface DragDropProps {
	handleFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
	handleFileDrop: (event: DragEvent<HTMLDivElement>) => void;
	text: string;
	info: string;
	style?: React.CSSProperties;
	accept?: string;
	multiple?: boolean;
	disable?: boolean;
	capture?: boolean | 'user' | 'environment';
}

const DragDropContainer = styled('div')<Pick<DragDropProps, 'disable'>>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 658px;
	height: 155px;
	border: ${({ disable }) =>
		disable ? '1px dashed var(--gray-g-400, #ACACAC)' : '1px dashed var(--gray-g-100, #ffbe00)'};
	background: ${({ disable }) => (disable ? '#F1F1F1' : '#fff9e6')};
	color: ${({ disable }) => (disable ? 'var(--gray-g-400, #ACACAC)' : '#333')};
	cursor: ${({ disable }) => (disable ? 'not-allowed' : 'pointer')};
	border-radius: 8px;

	.text {
		font-size: 14px;
		font-weight: 600;
		line-height: 24px;
	}

	.file-format-text {
		font-size: 12px;
		font-weight: 400;
		@media screen and (max-width: 600px) {
			margin-left: 4px;
			margin-right: 4px;
			text-align: center;
		}
	}

	@media screen and (max-width: 600px) {
		width: 90vw;
	}
`;

const ImageContainer = styled('div')<Pick<DragDropProps, 'disable'>>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	background: ${({ disable }) => (disable ? '#E4E4E4' : '#ffecb3')};
	border-radius: 50%;
	margin-bottom: 15px;
`;

const DragDrop: React.FC<DragDropProps> = ({
	handleFileChange,
	handleFileDrop,
	text = 'Select images to upload',
	info = 'Max upload 3 images',
	style,
	accept = 'image/png, image/jpeg, image/gif',
	multiple = false,
	disable = false,
	capture = false,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);

	const handleClick = () => {
		if (inputRef.current) {
			inputRef.current.click();
		}
	};

	const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
	};

	return (
		<DragDropContainer
			onClick={handleClick}
			style={style}
			onDrop={handleFileDrop}
			onDragOver={handleDragOver}
			disable={disable}
		>
			<ImageContainer disable={disable}>
				<UploadIcon fill={disable ? '#ACACAC' : '#E6AB00'} />
			</ImageContainer>
			<input
				ref={inputRef}
				type="file"
				multiple={multiple}
				onChange={handleFileChange}
				hidden
				accept={accept}
				disabled={disable}
				capture={capture ? 'user' : undefined}
			/>
			<p className="text">{text}</p>
			<p className="file-format-text">{info}</p>
		</DragDropContainer>
	);
};

export default DragDrop;
